import { SHTypography } from "@components/design-systems";
import { MAAnalysisDataDTO } from "@models/managed-accounts/entities/step/fee";
import { ManagedAccountFieldTypeValue } from "@models/managed-accounts/enums/fieldTypeValue";
import { memo } from "react";

interface DropdownCellProps {
  analysisData?: MAAnalysisDataDTO;
}
export const DropdownCell = memo(({ analysisData }: DropdownCellProps) => {
  return (
    <SHTypography variant="body3" colorVariant="third" lineHeight="120%">
      {analysisData?.value === ManagedAccountFieldTypeValue.Multiple
        ? ManagedAccountFieldTypeValue.Multiple
        : analysisData?.value}
    </SHTypography>
  );
});
